/**
 * Zeitstempel vom Backend korrekt als UTC interpretieren, bevor sie lokal
 * (deutsche Zeitzone) angezeigt werden.
 *
 * Hintergrund/Bug: SQLite's DEFAULT (datetime('now')) (verwendet für so gut
 * wie jede *_at-Spalte im gesamten Schema) liefert UTC im Format
 * "JJJJ-MM-TT HH:MM:SS" - mit Leerzeichen statt "T" und OHNE Zeitzonen-
 * Kennzeichnung ("Z"/Offset). `new Date("JJJJ-MM-TT HH:MM:SS")` wird von
 * Browsern (V8) als LOKALE Zeit interpretiert (nicht als UTC), wodurch die
 * eigentlich nötige UTC->lokal-Umrechnung stillschweigend ausfällt - eine um
 * 6:36 Uhr UTC geschriebene Aktivität erschien dadurch fälschlich als
 * "6:36 Uhr" statt korrekt als "8:36 Uhr" (MESZ, UTC+2). Bereits eindeutige
 * ISO-Strings (z.B. von Discord: "...T...+00:00"/"...Z") bleiben unverändert
 * - nur das mehrdeutige SQLite-Format wird korrigiert.
 */
/** Für Aufrufer, die toLocaleString() mit eigenen Format-Optionen benötigen. */
export function parseServerDate(raw: string): Date {
  const isUnambiguousIso = raw.includes("T") || /[+-]\d{2}:\d{2}$/.test(raw) || raw.endsWith("Z");
  return new Date(isUnambiguousIso ? raw : `${raw.replace(" ", "T")}Z`);
}

/** z.B. "2.9.2026, 08:36:00" (Datum + Uhrzeit, deutsches Format). */
export function formatDateTime(raw: string): string {
  return parseServerDate(raw).toLocaleString("de-DE");
}

/** Nur das Datum, z.B. "2.9.2026". */
export function formatDate(raw: string): string {
  return parseServerDate(raw).toLocaleDateString("de-DE");
}

/** Nur die Uhrzeit, z.B. "08:36". */
export function formatTime(raw: string): string {
  return parseServerDate(raw).toLocaleTimeString("de-DE", { hour: "2-digit", minute: "2-digit" });
}
